module.exports = __webpack_public_path__ + "static/assets/88629a9aa064dd71de7f4a6d122444ae.png";